module.exports = __webpack_public_path__ + "static/media/Spinner-1s-200px.0c6f34a3.gif";